import { getService } from '@/lib/DI/injector';

/**
 * @param {string} key
 * @param {object} [parameters]
 *
 * @returns {string}
 */
export const langFilter = (key, parameters = {}) => {
    /**
     * @type {LangService}
     */
    const langService = getService('langService');
    return langService.getText(key, parameters);
};

export const l = langFilter;

/**
 * Displays the appropriate lang key based on the count supplied in 'value'.
 * If 'value' is === 1 it will use "{key}" otherwise it will use "{key}__PLURAL".
 *
 * @param {number} value
 * @param {string} key
 * @param {object} [parameters]
 *
 * @return {string}
 */
export const langPluralFilter = (value, key, parameters = {}) => {
    /**
     * @type {LangService}
     */
    const langService = getService('langService');
    return langService.getText(
        value === 1 ? key : `${key}--PLURAL`,
        parameters
    );
};
